import LightboxImage from "../../../../src/components/mdx/lightbox-image/LightboxImage";
import * as React from 'react';
export default {
  LightboxImage,
  React
};